module.exports = __webpack_public_path__ + "static/media/alert-Icon.457ba9e1.svg";